import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import { 
    getCourseIndex, fetchCourseIndex, 
    getPublicClassList, fetchPublicClassList,
    getProviderIndex, fetchProviderIndex, 
  } from '../../../store/client'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import SearchBar from '../../../shared/ui/SearchBar'

import ProviderCard from './ProviderCard'
import CourseCard from './CourseCard'
import PublicClassCard from './PublicClassCard'

import { Typography } from '@material-ui/core'
import { fade, withStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

const styles = theme => ({
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#cacaca', 0.3),
    '&:hover': {
      backgroundColor: fade('#cacaca', 0.3),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    padding: theme.spacing(0, 0.5),
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    top: 0,
    cursor:'pointer'
  },  
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 0, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    paddingRight: `calc(1em + ${theme.spacing(2)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '20ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
  boxResult: {
    position: 'absolute',
    padding: theme.spacing(2),
    background: 'white',
    width: '300px',
    top: theme.spacing(6),
    border: '1px solid lightgrey'
  },
  boldText: {
    fontWeight: 'bold'
  }
})

const SearchBarView = ({ theme, classes, children, sidePanels, ...props }) => {

  const { publicClasses, courses, providers, fetchPublicClasses, fetchCourses, fetchProviders } = props

  useEffect(() => {
      if(!courses.lastFetched){
          fetchPublicClasses()
          fetchCourses()
          fetchProviders()
      }
  }, [courses.lastFetched])

  const navigationContext = useContext(NavigationContext)  
  const [search, setSearch] = useState('')

  const getCourseDetailLink = (row) => {
      return `/course/${row.uid}`
  }
  
  const getProviderDetailLink = (row) => {
      return `/provider/${row.uid}`
  }
  
  const getPublicClassDetailLink = (row) => {
      return `/course/${row.course.uid}`
  }

  const handleChange = event => {
      setSearch(event.target.value)
  }

  const handleKeyDown = event => {
      if (event.key === 'Enter') {
          if(search !== '')
              navigationContext.openLink('/?q='+search)
              setSearch('')
      }
    }

  const filteredProviders = providers.lastFetched ? providers.data.records.filter(item => item.name.toLowerCase().indexOf(search) > -1) : []
  const filteredCourses = courses.lastFetched ? courses.data.records.filter(item => item.name.toLowerCase().indexOf(search) > -1) : []
  const filteredClasses = publicClasses.lastFetched ? publicClasses.data.records.filter(item => item.course.name.toLowerCase().indexOf(search) > -1) : []
  
  return (
    <Box display='flex' flexGrow={1}>
      <SearchBar 
          search={search} 
          onClear={() => setSearch('')} 
          onEnter={handleKeyDown}
          onChange={handleChange}
      />

      { search !== '' &&
        <Box className={classes.boxResult}>
          <Box>
            <Box>
              <Typography variant='body1' className={classes.boldText}>
                  Upcoming Class
              </Typography>
            </Box>
            <Box>
              { filteredClasses.length > 0 && filteredClasses.splice(0, 2).map(item => 
                  <Box mt={1} mb={1} onClick={() => setSearch('')}>
                      <PublicClassCard theme={theme} classes={classes}
                          item={item}
                          linkTo={getCourseDetailLink(item)}
                          variant='horizontal'
                          />
                  </Box>
              )}
              { publicClasses.lastFetched && filteredClasses.length <= 0 &&
              <Box mt={1} mb={1} display='flex' justifyContent='center' className={classes.emptyText}>
                  No classes found
              </Box>
              }
            </Box>
          </Box>
          <Box>
            <Box>
              <Typography variant='body1' className={classes.boldText}>
                  Course
              </Typography>
            </Box>
            <Box>
              { filteredCourses.length > 0 && filteredCourses.splice(0, 3).map(item => 
                  <Box mt={1} mb={1} onClick={() => setSearch('')}>
                      <CourseCard theme={theme} classes={classes}
                          item={item}
                          linkTo={getCourseDetailLink(item)}
                          variant='horizontal'
                          target={'_self'}
                          />
                  </Box>
              )}
              { courses.lastFetched && filteredCourses.length <= 0 &&
              <Box mt={1} mb={1} display='flex' justifyContent='center' className={classes.emptyText}>
                  No courses found
              </Box>
              }
            </Box>
          </Box>
          <Box>
            <Box>
              <Typography variant='body1' className={classes.boldText}>
                  Training Provider
              </Typography>
            </Box>
            <Box>
              { filteredProviders.length > 0 && filteredProviders.slice(0, 3).map(item => 
                <Box mt={1} mb={1} onClick={() => setSearch('')}>
                    <ProviderCard 
                        item={item} 
                        showVisitButton={false} 
                        linkTo={getProviderDetailLink(item)}
                        target="_self"
                    />
                </Box>
              )}

              { providers.lastFetched && filteredProviders.length <= 0 &&
                <Box mt={1} mb={1} display='flex' justifyContent='center' className={classes.emptyText}>
                    No providers found
                </Box>
              }
            </Box>
          </Box>
        </Box>
      }
    </Box>
  )
}

const mapStateToProps = (state, ownProps) => {
    return {
        publicClasses: getPublicClassList(state),
        providers: getProviderIndex(state, "", null),
        courses: getCourseIndex(state, '', null)
    }
  }
  
  const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchPublicClasses: () => {
            dispatch(fetchPublicClassList(true))
        },
        fetchProviders: () => {
            dispatch(fetchProviderIndex("", null))
        },
        fetchCourses: (fetchMore) => {
            dispatch(fetchCourseIndex('', {size:50}, true, fetchMore))
        },
    }
  }

export default withStyles(styles, { withTheme: true })(
    connect(
        mapStateToProps,
        mapDispatchToProps
      )(SearchBarView)
)
